module.exports = __webpack_public_path__ + "static/media/roberto-casati-les-modules-evidenceb.f30b244e.mp4";